import { TableRow, TableRowProps } from "@mui/material";
import { TABLE_ROW_FONT_SIZE, TABLE_ROW_PADDING_X } from "../constants/table.constants";

export function TableBodyRow({
    paddingY,
    sx,
    ...props
 }: TableRowProps & { paddingY: string }){
    return(
        <TableRow
            sx={{
                "& .MuiTableCell-root": {
                    paddingY: paddingY,
                    paddingX: TABLE_ROW_PADDING_X,
                    fontSize: TABLE_ROW_FONT_SIZE,
                    borderRight: "1px solid #e0e0e0",
                },
                "& .MuiTableCell-root:last-of-type": {
                    borderRight: "none",
                },
                ...sx
            }}
            {...props}
        />
    )
}